// extracted by mini-css-extract-plugin
export default {"app":"app_app__18f1C","button":"app_button__9ygTO","header":"app_header__LiWS3","title":"app_title__svlRb"};